import { get, chain } from "lodash"
import { createSelector } from "reselect"

export const getHasError = (state) => get(state, "modules.accountTerms.hasError")

const getAccountMeta = (state) => get(state, "global.selected.accountMeta")
const getTermsValue = (state) => get(state, "global.data.accountTerms.data.value")
export const getTermsVersion = (state) => get(state, "global.data.accountTerms.data.version")
export const getTermsLicense = (state) => get(state, "global.data.accountTerms.data.license")

export const getTerms = createSelector(
  [getTermsValue, getAccountMeta],
  (rawTerms, accountMeta) => chain(rawTerms)
    .replace(/(?:\r\n|\r|\n)/g, "<br>")
    .replace("$legalName", `<b>${accountMeta.legalName}</b>`)
    .value(),
)
